module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-400italic.woff2?b61a9055d92ac56c15cacf4271d4f072";